import Model from "@/models/Model";
import User from "@/models/User";

export default class Group extends Model {
    resource() {
        return "groups";
    }

    users() {
        return this.hasMany(User);
    }
}
